import TrafoImage from "../assets/trafo.svg";
import SmartLoggerImage from "../assets/smartLogger.svg";

import { Box, Typography } from "@mui/material";
import { Handle, NodeProps, Position } from "reactflow";
import PrimaryBaseButton from "../../../main/components/PrimaryBaseButton";
import { InverterImage } from "./InverterImage";
import { BreakerImage } from "./BreakerImage";

const defaultNodeFontSize = "16px";
const defaultNodeFontWeight = "900";

export function DJMTDJBTNode({
    data,
}: NodeProps<{
    type: "on" | "off" | "notelemetry" | "unknown";
    isBottomSource?: boolean;
    isTopSource?: boolean;
    onClick: () => void;
}>) {
    return (
        <Box onClick={data.onClick} sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "4px" }}>
            <Box>
                <BreakerImage
                    type={data.type}
                    width={25}
                    height={25}
                />
                {data.isBottomSource ? <>
                    <Handle
                        type="source"
                        position={Position.Bottom}
                        id="DJMTDJBTBottom"
                        style={{ background: "#555" }}
                    />
                </> : <>
                    <Handle
                        type="target"
                        position={Position.Bottom}
                        id="DJMTDJBTBottom"
                        style={{ background: "#555" }}
                    />
                </>}
                {data.isTopSource ? <>
                    <Handle
                        type="source"
                        position={Position.Top}
                        id="DJMTDJBTTop"
                        style={{ background: "#555" }}
                    />
                </> : <>
                    <Handle
                        type="target"
                        position={Position.Top}
                        id="DJMTDJBTTop"
                        style={{ background: "#555" }}
                    />
                </>}
            </Box>
        </Box>
    );
}

export function EndPointNode() {
    return (
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "4px" }}>
            <Box>
                <Box sx={{ width: 30, height: 30, borderRadius: 15, backgroundColor: "transparent" }}><></></Box>
                <Handle
                    type="source"
                    position={Position.Bottom}
                    id="releProtecaoBottom"
                    style={{ background: "#555" }}
                />
            </Box>
        </Box>
    );
}

export function TrafoNode({ data }: NodeProps<{ isBottomTarget?: boolean, isTopTarget?: boolean }>) {
    return (
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "4px" }}>
            <Box>
                <img
                    width={30}
                    height={30}
                    src={TrafoImage}
                    className="rounded"
                    alt="trafo"
                />
                {data.isTopTarget ?
                    <Handle
                        type="target"
                        position={Position.Top}
                        id="trafoTop"
                        style={{ background: "#555" }}
                    />
                    :
                    <Handle
                        type="source"
                        position={Position.Top}
                        id="trafoTop"
                        style={{ background: "#555" }}
                    />}
                {data.isBottomTarget ?
                    <Handle
                        type="target"
                        position={Position.Bottom}
                        id="trafoBottom"
                        style={{ background: "#555" }}
                    />
                    :
                    <Handle
                        type="source"
                        position={Position.Bottom}
                        id="trafoBottom"
                        style={{ background: "#555" }}
                    />}
            </Box>
        </Box>
    )
}

export function TrafoTitleNode({ data }: NodeProps<{ firstTemperature: number; secondTemperature: number; thirdTemperature: number; }>) {
    return (
        <Box>
            <Typography sx={{ fontWeight: defaultNodeFontWeight, fontSize: defaultNodeFontSize, textAlign: "center" }}>{data.firstTemperature} ºC</Typography>
            <Typography sx={{ fontWeight: defaultNodeFontWeight, fontSize: defaultNodeFontSize, textAlign: "center" }}>{data.secondTemperature} ºC</Typography>
            <Typography sx={{ fontWeight: defaultNodeFontWeight, fontSize: defaultNodeFontSize, textAlign: "center" }}>{data.thirdTemperature} ºC</Typography>
        </Box>
    );
}

export function SmartLoggerNode() {
    return (
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "4px" }}>
            <Box>
                <img
                    width={25}
                    height={25}
                    src={SmartLoggerImage}
                    className="rounded"
                    alt="samartLogger"
                />
                <Handle
                    type="source"
                    position={Position.Top}
                    id="smartLoggerTop"
                    style={{ background: "#555" }}
                />
                <Handle
                    type="source"
                    position={Position.Bottom}
                    id="smartLoggerBottom"
                    style={{ background: "#555" }}
                />
            </Box>
        </Box>
    );
}

export function InversorNode({
    data,
}: NodeProps<{
    type: "on" | "off" | "notelemetry" | "unknown";
    name?: string;
    efficiency?: number | string;
    onClick?: () => void;
}>) {
    const { type, name, efficiency, onClick } = data;

    const efficiencyLabel = efficiency === "-" ? "-" : `${efficiency} MW`;

    return (
        <Box onClick={onClick} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Box>
                <InverterImage
                    type={type}
                    width={30}
                    height={30}
                />
                <Handle
                    type="target"
                    position={Position.Top}
                    id="InversorTop"
                    style={{ background: "#555" }}
                />
            </Box>
            <Box>
                <Typography sx={{ fontWeight: defaultNodeFontWeight, fontSize: defaultNodeFontSize, textAlign: "center" }}>{name}</Typography>
                <Typography sx={{ fontWeight: defaultNodeFontWeight, fontSize: defaultNodeFontSize, textAlign: "center" }}>{efficiencyLabel}</Typography>
            </Box>
        </Box>
    );
}

export function Border({ data }: NodeProps<{ ugName: string, width: number, height: number }>) {
    return (
        <>
            <Typography sx={{ fontWeight: defaultNodeFontWeight, fontSize: defaultNodeFontSize, textAlign: "start", marginBottom: "6px" }}>{data.ugName}</Typography>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", border: "1px solid #FFF", borderRadius: "8px", padding: "8px", gap: "8px", width: data.width, height: data.height }}>

            </Box>
        </>
    );
}

export function TitleNode({ data }: NodeProps<{ title: string, fontSize?: string | number }>) {
    return (
        <Typography sx={{ fontWeight: defaultNodeFontWeight, fontSize: data.fontSize ?? defaultNodeFontSize, textAlign: "center" }}>{data.title}</Typography>
    )
}

export function StringButton({ data }: NodeProps<{ onClick: () => void }>) {
    return (
        <PrimaryBaseButton onClick={data.onClick} fontSize={defaultNodeFontSize} sx={{ minWidth: "min-content", padding: "0px 4px" }} heigth={"min-content"} title="strings" />
    )
}